import $ from 'jquery';


export default () => {

    var current_photo = null;
    var gallery = $(".photo-wrap");


    $('.photo-wrap').on('click', function () {
        current_photo = $(this);
        console.log($(current_photo));

        update_gallery(this);
    })

    function update_gallery(that) {
        var modal = $($(that).attr('data-modal'));

        $(modal).find('.title').html('');
        $(modal).find('.caption').html('');

        var index = $(that).attr('data-index');
        var url = $(that).attr('data-url');
        var title = $(that).attr('data-title');
        var caption = $(that).attr('data-caption');

        $(modal).find('img').attr('src', url);
        $(modal).find('.title').html(title);
        $(modal).find('.caption').html(caption);
        $(modal).modal('show');
    }

    $("#btnNext").on('click', function () {
        next();
    });

    function next() {
        var current_index = $(current_photo).attr('data-index');
        var next_photo = null;
        console.log('gallery: ' + (gallery.length - 1));
        console.log('index current: ' + $(current_photo).attr('data-index'));
        if (parseInt(current_index) === (gallery.length - 1)) {
            console.log(1);
            next_photo = gallery[0];
        } else {
            console.log(2);
            current_index++;
            next_photo = gallery[current_index];
        }
        current_photo = next_photo;
        console.log('index next: ' + $(current_photo).attr('data-index'));
        update_gallery(next_photo);
    }


    $("#btnPrev").on('click', function () {
        prev();
    });

    function prev() {
        var current_index = $(current_photo).attr('data-index');
        var prev_photo = null;
        if (parseInt(current_index) === 0) {
            prev_photo = gallery[(gallery.length-1)];
        } else {
            current_index--;
            prev_photo = gallery[current_index];
        }
        current_photo = prev_photo;
        update_gallery(prev_photo);
    }

};




// WEBPACK FOOTER //
// ./scripts/libs/galleria.js